import { render } from "./FloatingPopup.vue?vue&type=template&id=639f239a&scoped=true"
import script from "./FloatingPopup.vue?vue&type=script&lang=js"
export * from "./FloatingPopup.vue?vue&type=script&lang=js"

import "./FloatingPopup.vue?vue&type=style&index=0&id=639f239a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639f239a"]])

export default __exports__